module.exports = __webpack_public_path__ + "img/ruan2.c925ea62.jpg";